import { NgModule } from '@angular/core';

import { CustomerOrderDialog } from './customer-order-dialog.component';

import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { MaterialModule } from 'app/main/material.module';
import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';

@NgModule({
    declarations: [
        CustomerOrderDialog,
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        MaterialModule,
        DialogHeaderModule,
    ],
    exports: [
        CustomerOrderDialog,
    ]
})

export class CustomerOrderDialogModule {}
